import React, { useContext, useMemo, useState } from 'react';

import { Grid, Skeleton, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useContainer } from 'unstated-next';

import ClassSessionsStudentToolbar from './ClassSessionsStudentToolbar';
import ClassSessionUserRow from './ClassSessionUserRow';
import AdminAuthContainer from '../../../AdminAuthContainer';
import { ClassSessionContext } from '../../../ClassSessionContext';
import { ClassSessionUsersContext } from '../ClassSessionUsersContext';

const StyledTable = styled(Table)`
    margin-bottom: 2rem;
`;

const Spacer = styled.div`
    margin: 1rem;
`;

const PaddedSkeleton = styled(Skeleton)`
    margin: 0.5rem 0;
`;

export const ClassSessionDetailUsers = () => {
    const { t } = useTranslation('portal');
    const { classSessionData } = useContext(ClassSessionContext);
    const { classSessionUsers, isLoading } = useContext(ClassSessionUsersContext);
    const { authMode } = useContainer(AdminAuthContainer);
    console.log(
        'ClassSessionDetailUsers classSessionData',
        classSessionData,
        'authMode',
        authMode,
        'classSessionUsers',
        classSessionUsers
    );

    const [searchText, setSearchText] = useState('');

    const filteredClassSessionUsers = useMemo(
        () =>
            classSessionUsers?.filter((zoomState) => {
                const includedInUserName = zoomState.user_name
                    .toLocaleLowerCase()
                    .includes(searchText.toLocaleLowerCase());
                const includedInSystem = zoomState.device?.system
                    ?.toLocaleLowerCase()
                    .includes(searchText.toLocaleLowerCase());
                const includedInVersion = zoomState.device?.version
                    ?.toLocaleLowerCase()
                    .includes(searchText.toLocaleLowerCase());
                const breakoutId = zoomState.breakout_id || t('main-room');
                const includedInBreakoutId = breakoutId.toLocaleLowerCase().includes(searchText.toLocaleLowerCase());

                return includedInUserName || includedInSystem || includedInVersion || includedInBreakoutId;
            }),
        [searchText, classSessionUsers, t]
    );

    const handleChangeSearch = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        setSearchText(event.target.value);
    };

    if (classSessionData.loading || isLoading) {
        return (
            <>
                <Grid container justifyContent="space-between">
                    <Grid item>
                        <Skeleton width={300} height={60} />
                    </Grid>
                    <Grid item>
                        <Skeleton width={150} height={60} />
                    </Grid>
                </Grid>
                <Spacer />
                <PaddedSkeleton height={35} />
                <PaddedSkeleton height={35} />
                <PaddedSkeleton height={35} />
                <PaddedSkeleton height={35} />
                <PaddedSkeleton height={35} />
                <Spacer />
                <Grid container justifyContent="flex-end">
                    <Skeleton width={400} height={50} />
                </Grid>
            </>
        );
    }

    return (
        <>
            <Table style={{ width: '100%', padding: '0px', margin: '0px' }}>
                <TableBody style={{ width: '100%', padding: '0px', margin: '0px' }}>
                    <TableRow style={{ width: '100%', padding: '0px', margin: '0px' }}>
                        <TableCell>
                            <ClassSessionsStudentToolbar
                                searchText={searchText}
                                handleChangeSearch={handleChangeSearch}
                            />
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            <Spacer />
            <StyledTable>
                <TableHead>
                    <TableRow>
                        <TableCell>{t('meeting-zoom-id')}</TableCell>
                        <TableCell>{t('user-name')}</TableCell>
                        <TableCell>{t('join-time')}</TableCell>
                        <TableCell>{t('leave-time')}</TableCell>
                        <TableCell>{t('room')}</TableCell>
                        <TableCell>{t('platform')}</TableCell>
                        <TableCell>{t('version')}</TableCell>
                        <TableCell>{t('actions')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {_.values(filteredClassSessionUsers!).map((classSessionUser, index) => (
                        <ClassSessionUserRow
                            classSessionUser={classSessionUser}
                            classSessionData={classSessionData}
                            key={index}
                        ></ClassSessionUserRow>
                    ))}
                </TableBody>
            </StyledTable>
        </>
    );
};
